<!-- eslint-disable vue/valid-v-for -->
<template>
  <div>
    <engagement-layout>
      <template #heading>{{ pageHeadingInfo.heading }}</template>
      <template #sub-heading>{{ pageHeadingInfo.subHeading }}</template>
      <template #left-side-bar>
        <mds-list-group with-icon size="medium">
          <mds-list-group-item
            v-for="d in menudata"
            v-bind:active="d.active"
            @click.native="selectmenu(d)"
            ><span>{{ d.text }}</span>
          </mds-list-group-item>
        </mds-list-group>
      </template>
      <template #right-side-bar>
        <div class="engagement-cardWrap">
          <adl-card
            v-for="c in carddata"
            :disabled="c.disabled"
            @clicked1="click1(c.click1)"
            @clicked2="click2(c.click2)"
            :title="c.title"
            class="engagement-card"
            :firstButtonText="c.firstButtonText"
            :secondButtonText="c.secondButtonText"
            :caption="c.caption == '' ? '' : c.caption + ' Instances'"
            :imagepath="c.imagepath"
            :showbutton="c.showbutton"
            :label="c.label"
            :imagewidth="c.width"
            :imageheight="c.height"
          ></adl-card>
        </div>
      </template>
      <!-- <template #footer>
        <page-footer>
          <template #action-button-left>
            <mds-button
              size="large"
              variation="flat"
              @click="onBack"
              icon="caret-left"
            >
              Back
            </mds-button>
          </template>
          <template #action-button-right> </template>
        </page-footer>
                      </template> -->
    </engagement-layout>
  </div>
</template>
<script>
import { EngagementLayout } from "../../component";
// import { PageFooter } from "../../component";

// import { MdsButton } from "@mds/button";
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
import AdlCard from "../custom/Card/Card.vue";

export default {
  components: {
    EngagementLayout,
    // PageFooter,
    // MdsButton,
    MdsListGroup,
    MdsListGroupItem,
    AdlCard,
  },
  props: {
    pageHeadingInfo: {
      type: Object,
    },
    carddata: {
      type: Array,
    },
    menudata: {
      type: Array,
    },
  },
  data() {
    return {};
  },

  methods: {
    click2(data) {
      this.$emit("OnClick2", data);
    },
    click1(data) {
      this.$emit("OnClick1", data);
    },
    onBack() {
      this.$router.back();
    },
    selectmenu(data) {
      this.$emit("onselectmenu", data);
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>
.engagement-cardWrap {
  .engagement-card {
    margin: $mds-space-1-x;
  }
}
</style>
